import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from '@chakra-ui/react';
import { Facebook as FacebookIcon } from '../../../components/Icons';
import { PANEL } from '../../../constants/panel';

const FacebookAccount = (props) => {
  const { currentPanel, isSubscribed } = props;
  const facebookUrl = useMemo(() => {
    let url = '/users/auth/facebook';
    const params = new URLSearchParams();
    if (currentPanel === PANEL.SIGN_UP) {
      params.set('signup', true);
    }
    if (isSubscribed) {
      params.set('marketing', true);
    }
    const urlQueries = new URLSearchParams(window.location.search);
    const encryptDataParams = urlQueries.get('encrypt_data');
    if (encryptDataParams) {
      // URLSearchParams will decode params once so we need to encode to handle uri contains plus symbol case
      // as fb redirect_uri
      const encryptData = encodeURIComponent(encryptDataParams);
      params.set('encrypt_data', encryptData);
    }
    const stringifyParams = params.toString();
    if (stringifyParams.length > 0) {
      url = `${url}?${stringifyParams}`;
    }
    return url;
  }, [currentPanel, isSubscribed]);

  return (
    <Link href={facebookUrl}>
      <FacebookIcon color="#1877F2" boxSize="40px" />
    </Link>
  );
};

FacebookAccount.propTypes = {
  currentPanel: PropTypes.oneOf([PANEL.LOGIN, PANEL.SIGN_UP]).isRequired,
  isSubscribed: PropTypes.bool,
};

export default FacebookAccount;
